import { format } from "date-fns";
import { DateFilterEvent } from "./types";

// date event helpers
const dateFormat = "yyyy-MM-dd";
const nowDate = new Date();

export const defaultDateEvent: DateFilterEvent = {
  event: "date",
  filter: {
    and: [
      {
        fraDato: { lte: format(nowDate, dateFormat) },
      },
      {
        tilDatoInklusiv: { gte: format(nowDate, dateFormat) },
      },
    ],
  },
  settings: {
    filterType: "today",
  },
};
